import { useQuery } from "@tanstack/react-query";
import { hasProjectInsights } from "@/app/actions/project/has-insights/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchHasProjectInsights(projectId?: number, enabled: boolean = true) {
  return useQuery({
    queryKey: [QueryKey.HAS_PROJECT_INSIGHTS, projectId],
    queryFn: () => {
      if (!projectId) return false;
      return hasProjectInsights(projectId);
    },
    enabled: enabled && !!projectId,
    staleTime: Infinity,
  });
}
